module.exports = __webpack_public_path__ + "img/association-institution-2.cc3aee87.png";